"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITE_HEADER_TABLET_HEIGHT = exports.SITE_HEADER_MOBILE_HEIGHT = void 0;
var SITE_HEADER_MOBILE_HEIGHT = 50;
exports.SITE_HEADER_MOBILE_HEIGHT = SITE_HEADER_MOBILE_HEIGHT;
var SITE_HEADER_TABLET_HEIGHT = 64;
exports.SITE_HEADER_TABLET_HEIGHT = SITE_HEADER_TABLET_HEIGHT;